var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.6C16.651 13.6 17.2753 13.8529 17.7356 14.3029C18.1959 14.753 18.4545 15.3635 18.4545 16C18.4545 16.6365 18.1959 17.247 17.7356 17.6971C17.2753 18.1471 16.651 18.4 16 18.4C15.349 18.4 14.7247 18.1471 14.2644 17.6971C13.8041 17.247 13.5455 16.6365 13.5455 16C13.5455 15.3635 13.8041 14.753 14.2644 14.3029C14.7247 13.8529 15.349 13.6 16 13.6ZM16 10C20.0909 10 23.5845 12.488 25 16C23.5845 19.512 20.0909 22 16 22C11.9091 22 8.41545 19.512 7 16C8.41545 12.488 11.9091 10 16 10ZM8.78364 16C10.1336 18.688 12.9236 20.4 16 20.4C19.0764 20.4 21.8664 18.688 23.2164 16C21.8664 13.312 19.0764 11.6 16 11.6C12.9236 11.6 10.1336 13.312 8.78364 16Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOn);
export default __webpack_public_path__ + "static/media/eye_on.37cc48fd2fe9798b977fe76117f8e7e6.svg";
export { ForwardRef as ReactComponent };